<template>
  <div class="blurred-feature" :class="{ 'blurred-feature--full-viewport': fullViewport }">
    <div class="blurred-feature__behind" aria-hidden="true">
      <slot />
    </div>
    <div class="blurred-feature__overlay">
      <UpsellCard
        :title="title"
        :lede="lede"
        :benefits="benefits"
        :badge-label="badgeLabel"
        :show-addon-badge="true"
        @book-call="$emit('book-call')"
      />
    </div>
  </div>
</template>

<script>
import UpsellCard from '@/components/upsell/UpsellCard';

export default {
  name: 'BlurredFeatureOverlay',
  components: { UpsellCard },
  props: {
    title: { type: String, required: true },
    lede: { type: String, default: null },
    benefits: { type: Array, default: () => [] },
    /** Passed through to UpsellCard BaseTag. Defaults to upsell.addon-label. */
    badgeLabel: { type: String, default: null },
    /**
     * When true, the overlay is centered on the viewport (position: fixed) and
     * the container kills page scroll. Use this on real app pages. Keep false
     * in dev showcases or inline contexts where the card should stay within
     * its own frame.
     */
    fullViewport: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.blurred-feature {
  position: relative;
  min-height: 480px;

  &__behind {
    filter: blur(5px);
    pointer-events: none;
    user-select: none;
  }

  &__overlay {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: calc(100% - 48px);
    max-width: 480px;
    z-index: 5;
  }

  &--full-viewport {
    height: 100%;
    max-height: var(--viewport-height);
    min-height: 0;
    overflow: hidden;

    .blurred-feature__behind {
      height: 100%;
      overflow: hidden;
    }

    .blurred-feature__overlay {
      position: fixed;
    }
  }
}
</style>
